import { render, staticRenderFns } from "./Allocations.vue?vue&type=template&id=a22a8cda&scoped=true"
import script from "./Allocations.vue?vue&type=script&lang=js"
export * from "./Allocations.vue?vue&type=script&lang=js"
import style0 from "./Allocations.vue?vue&type=style&index=0&id=a22a8cda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a22a8cda",
  null
  
)

export default component.exports